import React, { useState, useEffect } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { IS_FOREIGN_COUNTRY } from '../../utils/constants'

import {
  ContentContainer,
  Header,
  ImageContainer,
  Title,
  Text,
  MobileImageContainer,
  PlusBubble,
  BubbleText,
  MealImageContainer,
  MealImage,
} from './styles'

import { CAL_MAX_FEATURES } from '../CalMaxFeatures/constants'

const CalendarNewFeatures = () => {
  const { meal, mealUSA, all, auto, plan, sidekick, habit, rewards, lists } =
    useStaticQuery(graphql`
      query CalendarNewFeaturesQuery {
        meal: file(relativePath: { eq: "calmax/meal.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        mealUSA: file(relativePath: { eq: "calmax/meal-usa.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        all: file(relativePath: { eq: "calmax/temp/all-in-one.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        auto: file(relativePath: { eq: "calmax/temp/calendar-auto-syncing.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        plan: file(relativePath: { eq: "calmax/temp/planning.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        sidekick: file(relativePath: { eq: "calmax/temp/sidekick.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        habit: file(relativePath: { eq: "calmax/temp/routines-chores.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        rewards: file(relativePath: { eq: "calmax/temp/rewards.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        lists: file(relativePath: { eq: "calmax/temp/instacart-custom-list.webp" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
      }
    `)
  const [activeImageIndex, setActiveImageIndex] = useState(-1)

  const handleScroll = () => {
    const sections = document.querySelectorAll('.left-column section')
    let activeIndex = -1

    sections.forEach((section, index) => {
      const sectionTop = section.getBoundingClientRect().top + window.scrollY
      const sectionHeight = section.offsetHeight

      if (
        window.scrollY + window.innerHeight / 2.3 >= sectionTop &&
        window.scrollY + window.innerHeight / 2.3 < sectionTop + sectionHeight
      ) {
        activeIndex = index
      }
    })

    setActiveImageIndex(activeIndex)
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const featureImages = [
    all,
    auto,
    plan,
    sidekick,
    habit,
    rewards,
    IS_FOREIGN_COUNTRY ? meal : mealUSA,
    lists,
  ]
  const featureMobileImages = [
    all,
    auto,
    plan,
    sidekick,
    habit,
    rewards,
    IS_FOREIGN_COUNTRY ? meal : mealUSA,
    lists,
  ]

  return (
    <ContentContainer>
      <div className="container">
        <div className="left-column">
          <Header>Designed to Delight</Header>
          {CAL_MAX_FEATURES.map((feature, i) => (
            <section
              key={i}
              id={`section${i}`}
              className={activeImageIndex === i ? 'active-section' : 'inactive-section'}
            >
              <MobileImageContainer>
                <MealImage
                  image={featureMobileImages[i].childImageSharp.gatsbyImageData}
                  alt={feature.alt}
                />
              </MobileImageContainer>
              {feature.plus && (
                <PlusBubble blue>
                  <BubbleText>Calendar Plus</BubbleText>
                </PlusBubble>
              )}
              <Title>{feature.title}</Title>
              <Text>{feature.text}</Text>
            </section>
          ))}
        </div>
        <div className="right-column">
          {featureImages.map((image, index) => (
            <>
              {typeof image === 'object' ? (
                <MealImageContainer className={activeImageIndex === index ? 'active-image' : ''}>
                  <MealImage
                    image={image.childImageSharp.gatsbyImageData}
                    alt={CAL_MAX_FEATURES[index].alt}
                  />
                </MealImageContainer>
              ) : (
                <ImageContainer
                  aria-label={CAL_MAX_FEATURES[index].alt}
                  key={`${image.alt}-mobile`}
                  type="image/svg+xml"
                  data={image}
                  className={activeImageIndex === index ? 'active-image' : ''}
                  higher={index === 2 || index === 4 || index === 5}
                  highest={index === 3 || index === 7}
                >
                  <>svg-animation</>
                </ImageContainer>
              )}
            </>
          ))}
        </div>
      </div>
    </ContentContainer>
  )
}

export default CalendarNewFeatures
